/**
 * Short coin amounts for tight spaces: 950, 9,999, 12K, 150K, 1.5M. Under
 * ten thousand the full number reads fine; above it, thousands round to the
 * nearest K and millions show one decimal.
 */
export function formatShort(n: number): string {
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return `${trim((n / 1_000_000).toFixed(1))}M`;
  if (abs >= 10_000) return `${Math.round(n / 1000)}K`;
  return Math.round(n).toLocaleString('en-GB');
}

function trim(s: string): string {
  return s.endsWith('.0') ? s.slice(0, -2) : s;
}
